<template>
  <a-modal
    :confirm-loading="loading"
    title="宿主机关联"
    :visible="visible"
    :width="720"
    @cancel="reset"
    @ok="ok"
  >
    <a-form-model
      ref="form"
      :label-col="{
        span: 4,
        style: {
          textAlign: 'left'
        }
      }"
      :model="form"
      :rules="rules"
      :wrapper-col="{
        span: 20
      }"
    >
      <a-form-model-item label="物理机" prop="server" style="margin-bottom: 0">
        <source-select v-model="form.server" source-type="server"></source-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateHypervisorHost } from '@/api/hypervisor'
import SourceSelect from '@/components/select/SourceSelect'

export default {
  name: 'HostLinkModal',
  components: {
    SourceSelect
  },
  props: {
    hypervisorId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      visible: false,
      form: {
        id: '',
        server: undefined
      },
      rules: {
        os: [
          {
            message: '请选择物理机',
            required: true,
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    show (host) {
      this.form.id = host.id
      this.form.server = host.server
      this.visible = true
    },
    reset () {
      this.form = {
        id: '',
        server: undefined
      }
      this.$refs.form.resetFields()
      this.visible = false
    },
    ok () {
      this.$refs.form.validate(valid => {
        if (valid) {
          const params = {
            host_id: this.form.id,
            server_id: this.form.server.id
          }
          this.loading = true
          updateHypervisorHost(this.hypervisorId, params)
            .then(res => {
              this.$message.success(res.message)
              this.$emit('ok')
              this.reset()
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>
